export const SET_SERVICE_CATEGORIES = 'SET_SERVICE_CATEGORIES';
export const SET_SERVICE_CATEGORIES_ATTACH = 'SET_SERVICE_CATEGORIES_ATTACH';
export const PUSH_SERVICE_CATEGORY = 'PUSH_SERVICE_CATEGORY';
export const UPDATE_SERVICE_CATEGORY = 'UPDATE_SERVICE_CATEGORY';
export const DELETE_SERVICE_CATEGORY = 'DELETE_SERVICE_CATEGORY';
export const SET_CATEGORY_SERVICE_ARCHIVE = 'SET_CATEGORY_SERVICE_ARCHIVE';
export const SET_CATEGORY_ARCHIVE = 'SET_CATEGORY_ARCHIVE';

export const REORDER_SERVICE_CATEGORIES = 'REORDER_SERVICE_CATEGORIES';
export const REORDER_CATEGORY_SERVICES = 'REORDER_CATEGORY_SERVICES';
